var Ep2018ListConfig = {
   "partito-comunista":{
      "label": "Partito Comunista",
      "short_label": "PC",
      "color": "#9c030d",
      "political_pos": 10,
      "type": "lista",
      "logo": ""
   },
   "potere-al-popolo":{
      "label": "Potere al Popolo!",
      "short_label": "Potere al Popolo",
      "color": "#820526",
      "political_pos": 20,
      "type": "lista",
      "logo": ""
   }, 
   "liberi-e-uguali":{
      "label": "Liberi e Uguali",
      "short_label": "LeU",
      "color": "#fc3116",
      "political_pos": 30,
      "type": "lista",
      "logo": ""
   },
   "centro-sinistra":{
      "label": "Centro Sinistra",
      "short_label": "Centrosinistra",
      "color": "#e00831",
      "political_pos": 33,
      "type": "coalizione",
      "logo": null
   },
   "italia-europa-insieme":{
   "label": "Italia Europa Insieme",
   "short_label": "Insieme",
   "color": "#F3942F",
   "political_pos": 40,
   "type": "lista",
   "logo": ""
   },
   "partito-democratico":{
      "label": "Partito Democratico",
      "short_label": "PD",
      "color": "#DE1121",
      "political_pos": 50,
      "type": "lista",
      "logo": ""
   },
   "civica-popolare-lorenzin":{
      "label": "Civica Popolare Lorenzin",
      "short_label": "Civica Popolare",
      "color": "#DF147B",
      "political_pos": 60,
      "type": "lista",
      "logo": ""
   },
   "svp-patt":{
      "label": "SVP - PATT",
      "short_label": "SVP",
      "color": "#6b3d6a",
      "political_pos": 70,
      "type": "lista",
      "logo": ""
   },
   "europa":{
      "label": "+Europa",
      "short_label": "+Europa",
      "color": "#EF5E60",
      "political_pos": 80,
      "type": "lista",
      "logo": ""
   },
   "movimento-5-stelle":{
      "label": "Movimento 5 Stelle",
      "short_label": "M5S",
      "color": "#eecc00",
      "political_pos": 90,
      "type": "lista",
      "logo": ""
   },
   "noi-con-litalia-udc":{
      "label": "Noi con l'Italia UDC",
      "short_label": "NOI-UDC",
      "color": "#157EC6",
      "political_pos": 95,
      "type": "lista",
      "logo": ""
   },
   "partito-repubblicano-italiano-ala":{
      "label": "Partito Repubblicano Italiano - ALA",
      "short_label": "ALA",
      "color": "#3D9549",
      "political_pos": 105,
      "type": "lista",
      "logo": ""
   },
   "centro-destra":{
      "label": "Centro Destra",
      "short_label": "Centrodestra",
      "color": "#2b6dab",
      "political_pos": 123,
      "type": "coalizione",
      "logo": null
   },
   "forza-italia":{
      "label": "Forza Italia",
      "short_label": "FI",
      "color": "#0E68A7",
      "political_pos": 150,
      "type": "lista",
      "logo": ""
   },
   "lega":{
      "label": "Lega",
      "short_label": "Lega",
      "color": "#096224",
      "political_pos": 160,
      "type": "lista",
      "logo": ""
   },
   "fratelli-ditalia-con-giorgia-meloni":{
      "label": "Fratelli d'Italia con Giorgia Meloni",
      "short_label": "FDI",
      "color": "#074A71",
      "political_pos": 165,
      "type": "lista",
      "logo": ""
   },
   "casapound-italia":{
      "label": "Casapound Italia",
      "short_label": "Casapound",
      "color": "#525252",
      "political_pos": 170,
      "type": "lista",
      "logo": ""
   },
   "italia-agli-italiani":{
      "label": "Italia agli Italiani",
      "short_label": "Italia agli Italiani",
      "color": "#202020",
      "political_pos": 175,
      "type": "lista",
      "logo": ""
   },
   "grande-nord":{
      "label": "Grande Nord",
      "short_label": "Grande Nord",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "lista-del-popolo-per-la-costituzione":{
      "label": "Lista del Popolo per la Costituzione",
      "short_label": "Pop. per la Costituzione",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "altri":{
      "label": "Altre liste",
      "short_label": "Altri",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": null
   },
   "destre-unite-forconi":{
      "label": "Destre Unite - Forconi",
      "short_label": "Forconi",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "democrazia-cristiana":{
      "label": "Democrazia Cristiana",
      "short_label": "Democrazia Cristiana",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "il-popolo-della-famiglia":{
      "label": "Il Popolo della Famiglia",
      "short_label": "Popolo della Famiglia",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "italia-nel-cuore":{
      "label": "Italia nel Cuore",
      "short_label": "Italia nel Cuore",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "partito-valore-umano":{
      "label": "Partito Valore Umano",
      "short_label": "Valore Umano",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "patto-per-lautonomia":{
      "label": "Patto per l'Autonomia",
      "short_label": "Patto Autonomia",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "per-una-sinistra-rivoluzionaria":{
      "label": "Per una Sinistra Rivoluzionaria",
      "short_label": "Sinistra Rivoluzionaria",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "autodeterminatzione":{
      "label": "Autodeterminatzione",
      "short_label": "Autodeterminatzione",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "rinascimento-mir":{
      "label": "Rinascimento - MIR",
      "short_label": "Rinascimento",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "siamo":{
      "label": "Siamo",
      "short_label": "Siamo",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "sms-stato-moderno-solidale":{
      "label": "SMS - Stato Moderno Solidale",
      "short_label": "SMS",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "10-volte-meglio":{
      "label": "10 volte meglio",
      "short_label": "10 volte meglio",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   },
   "blocco-nazionale-per-le-liberta":{
      "label": "Blocco Nazionale per le Libertà",
      "short_label": "Blocco Naz. Libertà",
      "color": "#a7a099",
      "political_pos": 180,
      "type": "lista",
      "logo": ""
   }
}

export {Ep2018ListConfig}



// WEBPACK FOOTER //
// ./public/ep2018_listconfig.js